import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const OrderPrice = (props) => {
  let { targetPrice } = props

  if ( targetPrice === 'Vul velden in' || targetPrice === 'Geen product match' || targetPrice === 'Vul dimensies in' ) {
    return
  }

  return (
    <div>
      <p className="c-personalizer-row__title">Richtprijs mat</p>
      <div className="c-personalizer-row__price">
        {targetPrice}
        { targetPrice !== 'Op aanvraag*' ? (
          <span> incl. btw</span>
        ) : null }
      </div>
    </div>
  )
}

export default OrderPrice



// WEBPACK FOOTER //
// ./src/js/personalizer/components/OrderPrice.js